import * as React from "react";
import { ModelState } from "../../Models/ModelStateEnum";
import PbhRequestOrderCreate from "./PbhRequestOrderCreate";
import PbhRequestOrderUpdate from "./PbhRequestOrderUpdate";
import PbhRequestOrderView from "./PbhRequestOrderView";

const PbhRequestOrderInfo = props => {
  switch (props.ModelState) {
    case ModelState.Create:
      return (
        <PbhRequestOrderCreate
          resource="pbhrequestorder"
          basePath="pbhrequestorder"
          selectedData={props.selectedData}
        />
      );
    case ModelState.Edit:
      return (
        <PbhRequestOrderUpdate
          resource="pbhrequestorder"
          basePath="pbhrequestorder"
          selectedData={props?.DataSource}
          isPageDisabled={props?.isPageDisabled}
        />
      );
    default:
      return (
        <PbhRequestOrderView resource="pbhrequestorder" basePath="pbhrequestorder" selectedData={props?.DataSource} />
      );
  }
};

export default PbhRequestOrderInfo;
